// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"8f9809a5","1306":"0b82cb09","1838":"8f9809a5","3705":"8f9809a5","7171":"8f9809a5","7537":"e1dff671"}[chunkId] + ".chunk.css";
};